import axiosPost from "./axiosPost";

export const RNESRubroUpd = async (credentials, data) => {
    const body = {
        service: "RNESRubroUpd",
        params: {
            rnesRubroId: data?.id,
            rnesRubroNombre: data?.name,
            rnesRubroVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
